import { CompaniesOverview } from "@/1-pages/companies/overview/CompaniesOverview";
export default function Page() {
  return <CompaniesOverview />;
}
